import React from "react";
import { Typography, makeStyles, Button } from "@material-ui/core";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  banner: {
    width: "100%",
    height: "100vh",
    backgroundColor: "black",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
    },
    [theme.breakpoints.down(450)]: {
      height: "100vh",
    },
  },
  bannerText: {
    marginBottom: "50px",
    marginTop: "70px",
    color: theme.palette.primary.main,
    fontSize: "2rem",
  },
  bannerImage: {
    maxWidth: "40%",
    height: "auto",
  },
  navLink: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    margin: "0 1rem",
  },
}));

function Banner() {
  const classes = useStyles();
  return (
    <div className={classes.banner}>
      <Typography className={classes.bannerText}>WELCOME TO</Typography>
      <img
        src="/assets/images/D2P logo.png"
        alt="Decade 2 Publishing"
        className={classes.bannerImage}
      />
      <div>
        <div style={{ marginTop:"20px",padding: "20px 0" }}>
          <NavLink to="/privacy-policy" className={classes.navLink}>
            Privacy Policy
          </NavLink>
          <NavLink to="/terms" className={classes.navLink}>
            Terms Of Use
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default Banner;
